<template>
    <vue-bottom-sheet ref="myBottomSheet" class="bottom-menu" :swipe-able="false" @click.stop.prevent>
        <div class="bottom-menu__scroll">
            <div class="bottom-menu__title">Выберите комнату</div>
            <div tabindex="-1" class="bottom-menu__scroll-layout">
                <div class="bottom-menu__item main-text" v-for="(location, index) in rooms" :key="index" @click.stop.prevent="updateLocation(index)">
                    <span>{{ location }}</span>
                    <v-img v-if="activeGroup - offset == index" max-height="24px" max-width="24px" :src="require('@/assets/icons/checked_icon.svg')" class="d-inline-flex"/>
                </div>
            </div>
        </div>
    </vue-bottom-sheet>
</template>

<script>
import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";

export default {
    name: "BottomSheet",
    components: {
        VueBottomSheet
    },
    props: {
        activeGroup: {
            type: Number,
        },
        locations: {
            type: Array,
        },
        offset: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        rooms() {
            return JSON.parse(JSON.stringify(this.locations)).splice(this.offset, this.locations.length);
        },
    },
    methods: {
        open() {
            this.$refs.myBottomSheet.open();
        },
        close() {
            this.$refs.myBottomSheet.close();
        },
        updateLocation(index) {
            this.$emit("setRoom", index + this.offset);
            this.close();
        },
    }
}
</script>

<style lang="scss" scoped>
.bottom-menu {
    &::v-deep .bottom-sheet__card {
        background: #F7F7F9;
        bottom: 56px !important;
        padding: 0 0 12px;
        max-height: 70% !important;
    }

    &::v-deep .bottom-sheet__content {
        overflow: unset;
    }

    &__title {
        color: #130F26;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 22px;
        padding: 0 18px 10px;
        position: absolute;
        background: #F7F7F9;
        z-index: 10;
    }

    &__scroll {
        overflow-y: scroll;
        height: 100%;
    }

    &__scroll-layout {
        overflow-y: scroll;
        position: relative;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    &__item {
        padding: 10px 18px;
        display: flex;
        justify-content: space-between;

        &:hover {
            cursor: pointer;
            background: rgba(37, 37, 37, 0.1);
        }

        &:first-child {
            margin-top: 30px;
        }
    }
}
</style>